const DEFAULT_BASE_URL = 'https://www.milkywayplanner.com';

const EMAIL_FIGCAPTION_STYLE =
  'margin-top: 8px; font-size: 14px; font-style: italic; color: #5f748d; text-align: center;';

const UNSAFE_FIGURE_STYLE = /min\s*\(|margin-inline|\bvw\b|aspect-ratio/i;

/**
 * Last-mile HTML cleanup immediately before MailerLite / Resend.
 * Keep in sync with figure/caption handling in src/lib/newsletterContent.ts.
 * Regex-based so Deno edge functions do not need DOMParser.
 */
export function finalizeNewsletterHtmlForMailerLite(
  html: string,
  baseUrl: string = DEFAULT_BASE_URL,
): string {
  if (!html) return html;
  const base = baseUrl.replace(/\/$/, '');
  let out = normalizeInlineImageUrls(html, base);
  out = normalizeFigureCaptionStyles(out);
  return out;
}

function normalizeInlineImageUrls(html: string, base: string): string {
  return html.replace(/(<img\b[^>]*\ssrc=")([^"]*)(")/gi, (_match, pre, src, post) => {
    let url = src.trim();
    if (!url) return `${pre}${url}${post}`;
    if (url.startsWith('/')) url = `${base}${url}`;
    if (/\.webp(?:$|[?#])/i.test(url)) {
      url = url.replace(/\.webp(?=$|[?#])/i, '.jpg');
    }
    return `${pre}${url}${post}`;
  });
}

function normalizeFigureCaptionStyles(html: string): string {
  return html.replace(/<figcaption\b([^>]*)>/gi, (match, attrs: string) => {
    const styleMatch = attrs.match(/\sstyle="([^"]*)"/i);
    const style = styleMatch?.[1] ?? '';
    if (!style || UNSAFE_FIGURE_STYLE.test(style)) {
      const withoutStyle = attrs.replace(/\sstyle="[^"]*"/i, '');
      return `<figcaption${withoutStyle} style="${EMAIL_FIGCAPTION_STYLE}">`;
    }
    return match;
  });
}
